<template>
  <div class="items-center flex dialogcustomclass">
    <div class="flex items-center px-16 py-8 rounded-16px justify-center">
      <div class="w-full">
        <div class="w-full">
          <div class="flex items-center gap-4 ml-4">
            <img src="@/assets/images/BA 5.png" alt="image" class="w-24" />
            <h2
              class="lg:font-semibold md:font-semibold font-bold lg:text-3xl md:text-2xl text-xl"
            >
              What tools will you need to accomplish your goal?
            </h2>
          </div>

          <p class="fsize16 sm-fsize14 mt-8 px-4">
            No promos, No mentions, No Ads. Get a product that resonates with
            your Brand.
          </p>
        </div>
        <div
          class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-8 mad:gap-8 px-4 mt-6 gap-4"
        >
          <vx-card
            class="p-4 cursor-pointer shadow rounded-lg relative"
            v-for="(item, index) in cards"
            :key="'item-' + index"
            @click="selectedCard(item)"
            :class="{
              'bg-primary text-white': item.selectStatus
                ? item.selectStatus
                : false,
            }"
          >
            <div class="flex items-center">
              <img :src="item.img" alt="image" class="w-50px" />

              <p class="fsize16 font-semibold ml-4">
                {{ item.name }}
              </p>
            </div>
            <div
              class="absolute top-0 right-0 customMargin"
              v-if="!item.plans.includes(selectedPlan.plan.name)"
            >
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/scopeRequirements/crown2.png"
                alt="image"
                class="w-25px"
              />
            </div>
          </vx-card>
          <span class="validate" v-if="validatePlatform"
            >Please select required platform*</span
          >
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="upgradePlanPopup"
      width="30%"
      class="el-header-hide rounded-lg dialogcustomclass"
      :class="[
        upgradePlans.length == 2
          ? 'planspopup600'
          : upgradePlans.length == 3
          ? 'planspopup900'
          : upgradePlans.length == 4
          ? 'planspopup1100'
          : 'planspopup415',
      ]"
    >
      <div class="lg:p-4">
        <div class="flex justify-between">
          <div>
            <h2 class="font-semibold fsize20">Select Plan</h2>
            <p class="text-gray fsize14 pt-1">
              Please select your preferable subscription plan
            </p>
          </div>

          <feather-icon
            @click="Popupclose"
            icon="XIcon"
            class="cursor-pointer"
          />
        </div>
        <div
          v-if="upgradePlans.length"
          class="lg:grid md:grid flex gap-4 mt-8 role overflow-x-auto"
          :class="[
            upgradePlans.length == 2
              ? 'grid-cols-2'
              : upgradePlans.length == 3
              ? 'grid-cols-3'
              : upgradePlans.length == 4
              ? 'grid-cols-4'
              : 'grid-cols-1',
          ]"
        >
          <div
            class="bg-white shadow-md p-2 rounded-2xl wid-300px h-96 relative"
            v-for="plan in upgradePlans"
            :key="plan._id"
          >
            <div class="wid-280px">
              <div
                class="px-5 py-8 rounded-2xl customroundbrdr"
                :class="[
                  plan.name == 'Business'
                    ? 'bg-primary'
                    : plan.name == 'Essential'
                    ? 'bgprimary-light'
                    : 'col-ed',
                ]"
              >
                <div class="flex gap-4" v-if="plan.name != 'Business'">
                  <img
                    v-if="['Free', 'Starter'].includes(plan.name)"
                    class="w-5 h-5"
                    src="@/assets/images/new-log/dworld.png"
                    alt="white8"
                  />
                  <img
                    v-if="plan.name == 'Essential'"
                    class="w-5 h-5"
                    src="@/assets/images/new-log/white.png"
                    alt="white"
                  />
                </div>
                <div v-if="plan.name == 'Business'" class="flex gap-2">
                  <img
                    class="w-5 h-5 apps-gl object-contain"
                    :src="cards[0].img"
                    alt="white"
                  />
                  <img
                    class="w-5 h-5 object-contain apps-glr"
                    :src="cards[1].img"
                    alt="white2"
                  />
                  <img
                    class="w-5 h-5 object-contain"
                    :src="cards[2].img"
                    alt="white3"
                  />
                </div>
                <h1
                  class="fsize20 mt-2 font-semibold"
                  :class="[
                    plan.name == 'Business'
                      ? 'text-white'
                      : plan.name == 'Essential'
                      ? 'text-white'
                      : 'text-393939',
                  ]"
                >
                  {{ plan.name }} <br />subscription
                </h1>
              </div>

              <div class="flex mt-5 justify-center">
                <div class="w-full h270px">
                  <div
                    class="planswitch text-center justify-center 0 mb-4 mt-4"
                  >
                    <h2 class="text-dark font-bold fsize18">
                      {{ plan.sgPrice }}
                      <span class="fsize12"> / Monthly </span>
                    </h2>
                  </div>
                  <div class="y-scroll">
                    <div
                      class="grid grid-cols-1 gap-2 text-left mt-3"
                      v-for="(feature, index) in plan.features"
                      :key="'feature' + index"
                    >
                      <p
                        class="font-semibold fsize12 text-center text-424242"
                        :class="{
                          'text-primary': feature.status,
                          'text-grey': !feature.status,
                        }"
                      >
                        {{ feature.text }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-12 items-end flex btnfix">
              <button
                class="w-full cursor-pointer col-ed border-none rounded-12px fsize14 font-semibold py-4"
                @click="selectPlan(plan)"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      upgradePlans: [],
      upgradePlanPopup: false,
      selected: [],
      cards: [
        {
          id: "01",
          img: require("@/assets/images/Ecommerce.png"),
          name: "A Microsite",
          platform: "microsite",
          selectStatus: false,
          plans: [
            "Free",
            "Starter",
            "Essential",
            "Prototype",
            "Business",
            "Enterprise",
          ],
        },
        {
          id: "02",
          img: require("@/assets/images/andriod.png"),
          name: "A Website",
          platform: "website",
          selectStatus: false,
          plans: ["Essential", "Prototype", "Business", "Enterprise"],
        },
        {
          id: "03",
          img: require("@/assets/images/ios.png"),
          name: "Mobile Apps",
          platform: "IOS, Android",
          selectStatus: false,
          plans: ["Business", "Enterprise"],
        },
      ],
    };
  },
  components: {},
  methods: {
    Popupclose() {
      this.upgradePlanPopup = false;
    },
    setUpgradePlan(platform) {
      this.upgradePlans = [];

      if (platform.id == "02") {
        if (this.offerActivated) {
          this.upgradePlans.push(this.plans[2]);
          this.upgradePlans.push(this.plans[3]);
        } else {
          this.upgradePlans.push(this.plans[3]);
        }
      } else if (platform.id == "03") {
        if (this.offerActivated) {
          this.upgradePlans.push(this.plans[4]);
        } else {
          this.upgradePlans.push(this.plans[4]);
        }
      }
      for (let index = 0; index < this.upgradePlans.length; index++) {
        if (this.upgradePlans[index].name == "Starter")
          this.upgradePlans[index].sgPrice = "S$19";
        if (this.upgradePlans[index].name == "Prototype")
          this.upgradePlans[index].sgPrice = "S$89";
        if (this.upgradePlans[index].name == "Essential")
          this.upgradePlans[index].sgPrice = "S$399";
        if (this.upgradePlans[index].name == "Business")
          this.upgradePlans[index].sgPrice = "S$1599";
      }
    },

    async selectPlan(plan) {
      const selectedPlanDetails = {
        plan: plan,
        billing: !plan.selected ? plan.plans[0] : plan.plans[1],
      };
      this.$store.commit("scope/SET_PLAN", selectedPlanDetails);
      this.selectedCard(this.selected);
    },
    selectedCard(val) {
      this.selected = val;
      this.upgradePlanPopup = false;

      if (val.plans.includes(this.selectedPlan.plan.name)) {
        this.$store.commit("scope/UNSET_VALIDATE_PLATFORM", false);

        if (this.platforms.length === 0) {
          val.selectStatus = true;
          this.$store.commit("scope/SET_PLATFORMS", val);
        } else if (!this.platforms.filter((x) => x.id === val.id).length > 0) {
          val.selectStatus = true;
          this.$store.commit("scope/SET_PLATFORMS", val);
        } else if (this.platforms.filter((x) => x.id === val.id).length > 0) {
          this.$store.commit("scope/DELETE_PLATFORMS", val);
          val.selectStatus = false;
        }
        this.setWebsite(val);
      } else {
        this.setUpgradePlan(val);
        this.upgradePlanPopup = true;
      }
    },
    setWebsite(val) {
      if (val.id == "01") {
        const index = this.platforms.findIndex((x) => x.id == "02");
        if (index > -1) {
          const index1 = this.cards.findIndex((x) => x.id == "02");
          this.$store.commit("scope/DELETE_PLATFORMS", this.platforms[index]);
          this.cards[index1].selectStatus = false;
        }
      }
      if (val.id == "02") {
        const index = this.platforms.findIndex((x) => x.id == "01");
        if (index > -1) {
          const index1 = this.cards.findIndex((x) => x.id == "01");
          this.$store.commit("scope/DELETE_PLATFORMS", this.platforms[index]);
          this.cards[index1].selectStatus = false;
        }
      }
      // }
    },
  },
  mounted() {
    this.$store.commit("scope/EMPTY_SUITES");
    this.$store.commit("scope/SET_CURRENT_PAGE", "pagePlatforms");
    if (this.platforms.length > 0) {
      this.platforms.forEach((value) => {
        for (let index = 0; index < this.cards.length; index++) {
          if (this.cards[index].id == value.id) {
            this.cards[index].selectStatus = true;
          }
        }
      });
    }
  },
  computed: {
    ...mapState("scope", [
      "selectedPlan",
      "platforms",
      "validatePlatform",
      "plans",
      "offerActivated",
    ]),
  },
};
</script>
<style>
.input-effect {
  border: 0;
  padding: 7px 0;
  border-bottom: 3px solid #ccc;
}

.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
.customMargin {
  margin-top: -10px !important;
  margin-right: -10px !important;
}
.dialogcustomclass .el-dialog {
  border-radius: 15px !important;
}
.y-scroll {
  overflow-y: auto;
  height: 165px;
}
.y-scroll::-webkit-scrollbar {
  width: 5px;
  background-color: #f1f1f1;
  height: 5px;
}

/* Handle */
.y-scroll::-webkit-scrollbar-thumb {
  background: rgba(var(--vs-primary), 0.5) !important;
  border-radius: 0px 0px 4px 4px;
}
.customroundbrdr {
  border-radius: 15px !important;
}
</style>
